<template>
  <a
    class="reaction"
    @click.prevent="mouseclick"
    :class="{ 'reaction--active': reaction.active }"
    ref="el"
    @mouseover="mouseover"
    @mouseleave="mouseleave"
    href="#"
  >
    <span class="icon-emoji" :class="reaction.className"></span>
    <span class="reaction__count">{{ reaction.count }}</span>
  </a>
</template>
<script>
import api from './api'

const MEMBERS_DISPLAYED = 9;

export default {
  name: "Reaction",
  props: ["reaction", "reactionType", "reactableType", "reactableId"],
  data () {
    return {
      tooltip: null
    };
  },
  methods: {
    createTip (data) {
      return new Tooltip(this.$refs.el, {
        placement: "top",
        offset: "0,5px",
        title: this.tooltipContent(data),
        html: true,
        template:
          '<div class="reactors-tooltip tooltip-autobound tooltip tooltip--small" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>'
      });
    },
    mouseclick () {
      if (this.tooltip) {
        this.tooltip.dispose();
        this.tooltip = null;
      }
      this.$emit("click");
    },
    mouseover () {
      this.hover = true;
      if (this.tooltip) return;
      this.tooltip = {};
      this.fetchDataAndCreateTip();
    },
    mouseleave () {
      this.hover = false;
    },
    fetchDataAndCreateTip () {
      let requestObject = {
        params: {}
      };
      requestObject["params"][this.reactableType + "_id"] = this.reactableId;
      api.api
        .get("/reactions/" + this.reactionType, requestObject)
        .then((response) => {
          this.tooltip = this.createTip(response.data);
          this.hover && this.tooltip.show();
        });
    },

    tooltipContent (data) {
      let content = "<div>";

      if (this.reaction.active || data.self) {
        content +=
          '<div class="reactors-tooltip__name reactors-tooltip__self"><strong class="text-bold">You</strong> <em>(click to remove)</em></div>';
      }

      data.names.forEach(function(name) {
        content +=
          '<div class="reactors-tooltip__name">' +
          Grabcad.escapeHtml(name) +
          "</div>";
      });

      if (this.isOverLimit(data.total)) {
        content +=
          '<div class="reactors-tooltip__more">' +
          this.overLimitText(data.total, this.reaction.active || data.self) +
          "</div>";
      }

      content += "</div>";
      return content;
    },

    isOverLimit (total) {
      return total > MEMBERS_DISPLAYED;
    },

    overLimitText (total, member) {
      let left = total - MEMBERS_DISPLAYED;
      if (member) left--;
      return "and " + left + " more";
    }
  }
};
</script>
